export default "__VITE_ASSET__mCUggvNa__"